import { useEffect, useState } from 'react';

export type GeolocationError = GeolocationPositionError | { code: -1, message: string };
export const usePosition = () => {
  const [position, setPosition] = useState<GeolocationPosition | null>(null);
  const [error, setError] = useState<GeolocationError | null>(null);

  // callbacks will go here...
  useEffect(() => {
    const geo = navigator.geolocation;
    if (!geo) {
      setError({ code: -1, message: 'Geolocation is not supported' });
      return;
    }
    const onChange = (pos: GeolocationPosition) => {
      const clone: GeolocationPosition = {
        timestamp: pos.timestamp,
        coords: pos.coords,
      }; // need to clone else fails
      // console.log('setPosition', clone, pos.coords.latitude);
      setPosition(clone);
      setError(null);
      // console.log('onChangeDone', { ...position, error, isLoading: !position && !error });
    };
    const onError = (err: GeolocationPositionError) => {
      setError(err);
    };
    const watcher = geo.watchPosition(onChange, onError);
    geo.getCurrentPosition(onChange, onError);
    // eslint-disable-next-line consistent-return
    return () => { geo.clearWatch(watcher); };
  }, [setPosition, setError]);
  // console.log('UPD', position, { ...position, error, isLoading: !position && !error });
  return { ...position, error, isLoading: !position && !error };
};
